import type { Signal } from '@angular/core';
import { inject } from '@angular/core';
import type { CanMatchFn } from '@angular/router';

import { PlanProjectsService } from '#/app/shared/services/api/plan-projects.service';

import { resolveResourceAccessGuardResult } from './resource-access-guard';

/**
 * Guard that verifies a plan project set exists and belongs to the tenant in the route.
 * Prevents route matching if the plan project set doesn't exist or belongs to a different tenant,
 * allowing fallback routes to handle 404 display.
 */
export const planProjectAccessCanMatchGuard: CanMatchFn = (
  _routes,
  _segments,
  _currentSnapshot,
) => {
  const planProjectsService = inject(PlanProjectsService);
  const planIdParam = _currentSnapshot?.paramMap.get('planId') ?? '';
  const planProjectIdParam =
    _currentSnapshot?.paramMap.get('planProjectId') ?? '';

  return resolveResourceAccessGuardResult(
    [planIdParam, planProjectIdParam],
    (idSignals) => {
      const [planIdSignal, planProjectIdSignal] = idSignals as Signal<string>[];
      return planProjectsService.planProjectResource(
        planIdSignal,
        planProjectIdSignal,
      );
    },
  );
};
